import { trigger, state, style, transition, animate, group } from '@angular/animations';

export const slideBottom = [
  trigger('slideBottom', [
    state(
      'in',
      style({
        margin: '400px',
      }),
    ),
    state(
      'out',
      style({
        margin: '-100px 0 0 0',
        height: '0px',
      }),
    ),
    transition('in <=> out', animate(300)),
  ]),
];

export const slideInOut = [
  trigger('slideInOut', [
    state('in', style({ height: '*', opacity: 0 })),
    transition(':leave', [
      style({ height: '*', opacity: 1 }),

      group([animate(300, style({ height: 0 })), animate('200ms ease-in-out', style({ opacity: '0' }))]),
    ]),
    transition(':enter', [
      style({ height: '0', opacity: 0 }),

      group([animate(300, style({ height: '*' })), animate('400ms ease-in-out', style({ opacity: '1' }))]),
    ]),
  ]),
];
